var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"fill":"#000000"},attrs:{"xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"16","height":"16","viewBox":"0 0 30 30"}},[_c('path',{attrs:{"d":_vm.d}})])
}
var staticRenderFns = []

export { render, staticRenderFns }